/**
 * Request Header Component
 *
 * @module @features/requests/components/RequestDetails/components/RequestHeader
 */

import React from 'react';
import { Button, Badge } from '@dynamon-as/ui';
import { useI18n, useRequestTranslations } from '@shared/i18n';
import type { Request } from '@features/requests/types';
import { STATUS_COLORS } from '../../../constants';
import styles from '../RequestDetails.module.css';

/**
 * Props for RequestHeader component
 */
export interface RequestHeaderProps {
    request: Request;
    onBack: () => void;
}

/**
 * Displays request header with back button, title and status badge
 */
export function RequestHeader({
    request,
    onBack,
}: RequestHeaderProps): React.ReactElement {
    const { t } = useI18n();
    const { getStatusLabel } = useRequestTranslations();

    const statusColor = STATUS_COLORS[request.status] ?? 'neutral';
    const statusLabel = getStatusLabel(request.status);

    return (
        <div className={styles.header}>
            <Button
                text={t('requests.details.back')}
                color="secondary"
                variant="outlined"
                onClick={onBack}
                size="small"
            />
            <h2 className={styles.title}>{request.type}</h2>
            <Badge
                text={statusLabel}
                variant={statusColor}
            />
        </div>
    );
}
